import { useSelector } from 'react-redux';
import { ContainerPolicy } from '../../models';
import { selectContainerPolicies } from '../../selectors';

export const useContainerPolicies = (): ContainerPolicy[] => {
  const containerPolicies = useSelector(selectContainerPolicies);

  return containerPolicies;
};
